const ModalCookies = () => {
  const modalCookies = document.querySelector(".modal-cookies");

  if (modalCookies) {
    const acceptBtn = modalCookies.querySelector(".modal-cookies__accept-btn"); 
    
    const closeModal = () => {
      modalCookies.classList.remove("opened");
    }

    acceptBtn.addEventListener("click", closeModal);
  }
}

export default ModalCookies